import * as React from 'react';
import {
  SingleSelect,
  TextInput,
} from '../../../../widgets/FormikInputFieldV2';
import { COUNTRIES_SELECT_OPTIONS_USA_FIRST } from '../../../../constants';
import { useField, useFormikContext } from 'formik';
import { NotificationBox } from '@rtkwlf/ui';
import { OBAddress } from '../../../../types';

/**
 * A collection of address-related form input fields.
 * Must be used within a formik context with the following fields:
 *  - country
 *  - street
 *  - street2
 *  - region
 *  - postcode
 */
export const AddressFormInputs: React.FunctionComponent<{
  disabled?: boolean;
  showShippingNotification?: boolean;
}> = (props) => {
  const { disabled, showShippingNotification } = props;
  const formikContext = useFormikContext<OBAddress>();
  const [
    ,
    // skip first item in tuple
    { touched: streetTouched, error: streetError },
  ] = useField('street');

  const {
    values: { country },
  } = formikContext;

  const isUSorCAorEmpty = ['US', 'CA', '', undefined, null].includes(country);

  return (
    <>
      <SingleSelect
        name="country"
        id="selectCountry"
        placeholder="Choose a country"
        options={COUNTRIES_SELECT_OPTIONS_USA_FIRST}
        label="Country"
        className="pb-2"
        isDisabled={disabled}
        required
      />
      {showShippingNotification && !isUSorCAorEmpty && (
        <NotificationBox
          itemKey="shipping"
          notificationType="info"
          allowClose={false}
        >
          Sensors shipped outside of the United States or Canada may be subject
          to import, custom, or similar fees. Arctic Wolf does not cover these
          costs.
        </NotificationBox>
      )}

      <TextInput
        name="street"
        id="street"
        label="Street Address"
        disabled={disabled}
        required
      />
      <label
        id="street-optional"
        hidden={streetTouched && !!streetError}
        style={{ fontSize: '11px', color: 'grey', marginTop: '-14px' }}
      >
        Optional
      </label>
      <TextInput name="street2" disabled={disabled} />
      <TextInput name="city" label="City" disabled={disabled} required />

      {/*Will convert this to a dropdown of available states for USA and provinces for Canada*/}
      <TextInput
        name="region"
        label="State/Province/Region"
        disabled={disabled}
        required
      />
      <TextInput
        name="postcode"
        label="Postal/ZIP Code"
        disabled={disabled}
        required
      />
    </>
  );
};
